/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigOutputGradingRelevant } from './taskEvaluationConfigOutputGradingRelevant';
import type { TaskEvaluationConfigOutputFormalCriteriaSource } from './taskEvaluationConfigOutputFormalCriteriaSource';
import type { TaskEvaluationConfigOutputFormalCriteria } from './taskEvaluationConfigOutputFormalCriteria';
import type { TaskEvaluationConfigOutputFeedback } from './taskEvaluationConfigOutputFeedback';
import type { TaskEvaluationConfigOutputCompletionPolicyOverride } from './taskEvaluationConfigOutputCompletionPolicyOverride';
import type { TaskEvaluationConfigOutputCompletionMinLevelsOverride } from './taskEvaluationConfigOutputCompletionMinLevelsOverride';
import type { TaskEvaluationConfigOutputCompletionPolicyEffective } from './taskEvaluationConfigOutputCompletionPolicyEffective';
import type { TaskEvaluationConfigOutputCompletionMinLevelsEffective } from './taskEvaluationConfigOutputCompletionMinLevelsEffective';

/**
 * Configuration for the evaluation of a task
 */
export interface TaskEvaluationConfigOutput {
  mode?: string;
  gradingRelevant?: TaskEvaluationConfigOutputGradingRelevant;
  formalCriteriaSource?: TaskEvaluationConfigOutputFormalCriteriaSource;
  formalCriteria?: TaskEvaluationConfigOutputFormalCriteria;
  feedback?: TaskEvaluationConfigOutputFeedback;
  completionPolicyOverride?: TaskEvaluationConfigOutputCompletionPolicyOverride;
  completionMinLevelsOverride?: TaskEvaluationConfigOutputCompletionMinLevelsOverride;
  completionPolicyEffective?: TaskEvaluationConfigOutputCompletionPolicyEffective;
  completionMinLevelsEffective?: TaskEvaluationConfigOutputCompletionMinLevelsEffective;
}
